import React from "react";
import {ReactComponent as Spinner} from '../../assets/icons/spinner.svg';
import {Box} from "@mui/material";
import {makeStyles} from "@mui/styles";
import {useSelector} from "react-redux";
import {IAppState} from "../../store/models";

const useStyles = makeStyles(theme => ({
	"@keyframes loader": {
		"0%": {
			opacity: 0, transform: "rotate(0)"
		}, "100%": {
			opacity: 1, transform: "rotate(360deg)"
		}
	}, spinnerWrapper: {
		display: `flex`,
		justifyContent: `center`,
		alignItems: `center`,
		animation: `$loader 1s infinite linear`,
		height: `66px`,
		width: `66px`,
	}, loaderWrapper: {
		display: 'flex',
		flexFlow: 'column',
		rowGap: '2rem'
	}
}))

interface Props{
	withLogo?: boolean;
}

export const PageSpinner: React.FC<Props> = ({withLogo = true}) => {
	const {
		flyersBranch: {data: flyerBranch}, shelvesScreen, storeData: storeGlobalData,
	} = useSelector((state: IAppState) => state);
	const settingForPopup = storeGlobalData?.isFromFlyer ? flyerBranch : shelvesScreen?.data?.storeSetting;
	const logoUrl = settingForPopup?.logo || settingForPopup?.logoUrl || null;
	const classes = useStyles();
	return (
			<Box className={classes.loaderWrapper}>
			{
				logoUrl && withLogo &&
					<Box sx={{
						height: "64px"
					}}>
						<Box
							sx={{
								height: `100%`,
								maxHeight: `inherit`,
								maxWidth: `100%`,
								display: `flex`,
								justifyContent: `center`,
								alignItems: `center`,
								width: `inherit`,
								'& img': {
									maxWidth: `100%`, maxHeight: `inherit`, height: `100%`, width: `100%`, objectFit: `contain`,
								},

							}}
						>
							<img src={logoUrl} alt={""}/>
						</Box>
					</Box>
			}
			<Box className={classes.spinnerWrapper}>
				<Spinner/>
			</Box>
		</Box>
	)
}